import React from "react";
import CommonButton from "../../../components/buttons/CommonButton";
import PropTypes from "prop-types";
import CommonModal from "../../../components/Common/CommonModal";
import CommonInputFile from "../../../components/forms/CommonInputFile";
import {
  handleChange,
  handleChangeFile,
} from "../../../helpers/handleFormChanges";
import ErrorSwal from "../../../components/Swal/errorSwal";
import CommonInput from "../../../components/forms/CommonInput";

function PeriodoPersonalizadoModal({
  modalHook,
  valuesHook,
  uploadPeriodo,
  filtrosHook,
}) {
  const { periodoPersonalizadoModal, setPeriodoPersonalizadoModal } = modalHook;
  const { values, setValues } = valuesHook;
  const { filtros } = filtrosHook;

  const getMaxDataInicial = () => {
    if (!filtros.mes) return "";
    const date = new Date(Number(filtros.ano), Number(filtros.mes) - 1, 1);
    date.setMonth(date.getMonth() - 1);
    const maxAno = date.getFullYear();
    const maxMes = String(date.getMonth() + 1).padStart(2, "0");
    return `${maxAno}-${maxMes}`;
  };

  return (
    <CommonModal
      title="Periodo personalizado"
      is_open_modal={periodoPersonalizadoModal}
      set_is_open_modal={setPeriodoPersonalizadoModal}
      size="md"
      buttons={
        <CommonButton
          key={`upload-arquivo`}
          color="success"
          onClick={uploadPeriodo}
        >
          Enviar
        </CommonButton>
      }
    >
      <div className="row">
        <div className="col-lg-6 mb-3">
          <CommonInput
            label="Data inicial"
            id="data_inicial"
            value={values.data_inicial}
            type="month"
            max={getMaxDataInicial()}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
          />
        </div>
        <div className="col-lg-6 mb-3">
          <CommonInput
            label="Data final"
            id="data_final"
            value={values.data_final}
            type="month"
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            disabled
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 mb-3">
          <CommonInputFile
            id="arquivo"
            label="Extrato Bancário"
            onChange={(e) => {
              if (e.target.files && e.target.files[0]) {
                const file = e.target.files[0];
                const accept = ".pdf";
                const allowedTypes = accept.replace(/\s/g, "").split(",");
                const fileExt = file.name
                  .substring(file.name.lastIndexOf("."))
                  .toLowerCase();
                if (!allowedTypes.includes(fileExt)) {
                  ErrorSwal({
                    text: `Tipo de arquivo inválido.`,
                  });
                  e.target.value = "";
                  return;
                }
              }
              handleChangeFile(e, values, setValues);
            }}
            accept=".pdf"
          />
        </div>
      </div>
    </CommonModal>
  );
}

PeriodoPersonalizadoModal.propTypes = {
  modalHook: PropTypes.shape({
    periodoPersonalizadoModal: PropTypes.bool.isRequired,
    setPeriodoPersonalizadoModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  uploadPeriodo: PropTypes.func.isRequired,
  filtrosHook: PropTypes.shape({
    filtros: PropTypes.object.isRequired,
    setFiltros: PropTypes.func.isRequired,
  }).isRequired,
};

export default PeriodoPersonalizadoModal;
